import { SpyneTrait, ViewStream } from "spyne";
import { CodeBlockUtilsTraits } from "traits/code-block-utils-traits";

const baseTemplateStr = `
       new ViewStream({
           data:   {name: "Mundo"},
           template: "Hello {{name}}!",
           style:   "font-family:sans-serif;",
           tagName: "h3"
           
           
       }).appendToDom(document.body);
    `;

export class CodePlaygroundExamplesTemplatesTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codeplaygroundTemplates$";

    super(context, traitPrefix);
  }

  static codeplaygroundTemplates$RunAnimalExample() {
    const data = {
      animals: [
        {
          animal: "Blue Whale",
          img: "imgs/animals/whale.webp",
          dimensions: { length: "98", weight: "440,000" },
        },
        {
          animal: "Elephant",
          img: "imgs/animals/elephant.webp",
          dimensions: { length: "24.6", weight: "14,000" },
        },
        {
          animal: "Giraffe",
          img: "imgs/animals/giraffe.webp",
          dimensions: { length: "18", weight: "2,645" },
        },
      ],
    };

    const template = `
        {{#animals}}
          <section style="margin:0 1rem 1rem 0; max-width: 125px;">
             <img src="{{img}}" width="100" alt="" />
             <p style="margin:.5rem 0 0 0;">The <b>{{animal}}</b> can reach heights of up to {{dimensions.length}} feet,
               and can weigh as much as {{dimensions.weight}} pounds.</p>
          </section>
        {{/animals}}
    
    `;

    const props = {
      tagName: "article",
      style: "font-family:sans-serif; display:flex;",
      data,
      template,
    };

    return new ViewStream(props);
  }

  static codeplaygroundTemplates$AppendExample(appendType = "append") {
    let appendSelector = "";

    const vs = this.codeplaygroundTemplates$RunAnimalExample();
    vs.appendToDom(this.props.el.contentDocument.body);
    this.props.el.contentDocument.body.style["font-size"] = "14px";

    const data = {
      animal: "Sasquatch",
      img: "/./static/imgs/animals/sasquatch.webp",
      dimensions: { length: "9", weight: "900" },
    };

    const template = `<section style="margin:0 1rem 1rem 0; max-width: 125px;">
             <img src="{{img}}" width="100" alt="" />
             <p style="margin:.5rem 0 0 0;">The <b>{{animal}}</b> can reach heights of up to {{dimensions.length}} feet,
               and can weigh as much as {{dimensions.weight}} pounds.</p>
                 </section>`;

    if (appendType === "prependView") {
      vs.prependView(new ViewStream({ data, template }));
    } else if (appendType === "appendViewAfter") {
      appendType = "appendViewAfter";
      appendSelector = "section:nth-child(2)";
      vs.appendViewAfter(
        new ViewStream({ data, template }),
        "section:nth-child(2)",
      );
    } else {
      appendType = "appendView";
      vs.appendView(new ViewStream({ data, template }));
    }

    return `
    
        const data =  { animal: "Pygmy Shrew", img: "/./static/imgs/animals/sasquatch.webp", 
        dimensions: { length: "1.4 to 2.1 inches", weight: "1.2 to 2.7" } }

    const template = \`<section style="margin:0 1rem 1rem 0; max-width: 125px;">
             <img src="{{img}}" width="100" alt="" />
             <p style="margin:.5rem 0 0 0;">The <b>{{animal}}</b> can reach heights of up to {{dimensions.length}} feet,
               and can weigh as much as {{dimensions.weight}} pounds.</p>
                 </section>\`
    
    vs.${appendType}(new ViewStream({data, template}), ${appendSelector});
    
    
    `;
  }

  static codeplaygroundTemplates$PrependExample() {
    return this.codeplaygroundTemplates$AppendExample("prependView");
  }

  static codeplaygroundTemplates$AppendAfterExample() {
    return this.codeplaygroundTemplates$AppendExample("appendViewAfter");
  }

  static codeplaygroundTemplates$DotSyntax() {
    const data = {
      animals: [
        {
          animal: "Blue Whale",
          img: "imgs/animals/whale.webp",
          dimensions: { length: "98", weight: "440,000" },
        },
        {
          animal: "Elephant",
          img: "imgs/animals/elephant.webp",
          dimensions: { length: "24.6", weight: "14,000" },
        },
        {
          animal: "Giraffe",
          img: "imgs/animals/giraffe.webp",
          dimensions: { length: "18", weight: "2,645" },
        },
      ],
    };

    const template = `
        {{#animals}}
          <section style="margin:0 1rem 1rem 0; max-width: 125px;">
             <img src="{{img}}" width="100" alt="" />
             <p style="margin:.5rem 0 0 0;">The <b>{{animal}}</b> can reach heights of up to {{dimensions.length}} feet,
               and can weigh as much as {{dimensions.weight}} pounds.</p>
          </section>
        {{/animals}}
    
    `;

    const props = {
      tagName: "article",
      style: "font-family:sans-serif; display:flex;",
      data,
      template,
    };

    //new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    const vs = this.codeplaygroundTemplates$RunAnimalExample();
    vs.appendToDom(this.props.el.contentDocument.body);

    this.props.el.contentDocument.body.style["font-size"] = "14px";
    CodeBlockUtilsTraits.codeBlockUtil$FormatLines(
      [13, 14, 15, 16, 17, 18, 19],
      this.props.parentVsid,
    );

    return `
        const data = { animals: [
        { animal: "Blue Whale", img: "imgs/animals/whale.webp", 
          dimensions: { length: "98", weight: "440,000" } },
        { animal: "Elephant",   img: "imgs/animals/elephant.webp", 
          dimensions: { length: "24.6", weight: "14,000" } },
        { animal: "Giraffe",    img: "imgs/animals/giraffe.webp", 
          dimensions: { length: "18", weight: "2,645" } }
      ]};

 
    const template = \` {{#animals}}
                          <section style="margin:0 1rem 1rem 0; max-width: 125px;">
                             <img src="{{img}}" width="100" alt="" />
                             <p style="margin:.5rem 0 0 0;">The <b>{{animal}}</b> 
                              can reach heights of up to {{dimensions.length}} feet,
                              and can weigh as much as {{dimensions.weight}} pounds.</p>
                          </section>
                        {{/animals}}\`

 
    const props = {
      tagName: "article",
      style: "font-family:sans-serif; display:flex;",
      data, template
    }

 
    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);
    
    `;
  }

  codeplaygroundTemplates$Basic() {
    const data = { name: "Mundo" };
    const template = "Hola {{name}}!";

    const props = {
      style: "font-family:sans-serif",
      tagName: "h3",
      data,
      template,
    };

    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    return baseTemplateStr;
  }

  codeplaygroundTemplates$BasicLoop() {
    const data = {
      mcuCharacters: [
        { name: "Spider-Man" },
        { name: "Iron Man" },
        { name: "Captain America" },
        { name: "Thor" },
        { name: "Black Widow" },
      ],
    };

    const template = ` {{#mcuCharacters}}
                       <li>{{name}}</li>
                       {{/mcuCharacters}}`;

    const props = {
      style: "font-family:sans-serif; list-style-type:square",
      tagName: "ul",
      data,
      template,
    };

    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    CodeBlockUtilsTraits.codeBlockUtil$FormatLines(
      [11, 12],
      this.props.parentVsid,
    );

    return `   
    const data =       {mcuCharacters: [
                          { name: "Spider-Man" },
                          { name: "Iron Man" },
                          { name: "Captain America" },
                          { name: "Thor" },
                          { name: "Black Widow" }
                       ]};
     
    const template =  \`{{#mcuCharacters}}
                       <li>{{name}}</li>
                       {{\/mcuCharacters}}\`;
             
    const props = {
      data,
      template,
      style: "font-family:sans-serif; list-style-type:'square",
      tagName: "ul"
    };
  
    new ViewStream(props).appendToDom(document.body);
    `;
  }

  codeplaygroundTemplates$BasicArrayLoop() {
    const data = ["Athos", "Porthos", "Aramis"];

    const template = ` {{#}}
                       <li>{{.}}</li>
                       {{/}}`;

    const props = {
      style: "font-family:sans-serif; list-style-type:square",
      tagName: "ul",
      data,
      template,
    };

    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    CodeBlockUtilsTraits.codeBlockUtil$FormatLines(
      [12, 13],
      this.props.parentVsid,
    );

    return `   
    const data =    ["Athos", "Porthos", "Aramis"];


    const template = \` {{#}}
                       <li>{{.}}</li>
                       {{/}}\`;
             
    const props = {
      data,
      template,
      style: "font-family:sans-serif; list-style-type:'square",
      tagName: "ul"
    };
  
    new ViewStream(props).appendToDom(document.body);
    `;
  }

  codeplaygroundTemplates$ArrayOfStrings() {
    const data = [
      "Spider-Man",
      "Iron Man",
      "Captain America",
      "Thor",
      "Black Widow",
    ];

    const template = "Hola {{name}}!";

    const props = {
      data,
      template,
      style: "font-family:sans-serif",
      tagName: "h3",
    };

    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    return baseTemplateStr;
  }
}
